function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "2009E739-25C4-4677-9087-6B41766D7A43");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "In-App-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Checkout---Flat-69-Plan-(Single)-+-Paypal",
  transform: "translate(-244.000000, -474.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(128.000000, 390.000000)"
}, React.createElement("g", {
  id: "Group-11",
  transform: "translate(0.000000, 84.000000)"
}, React.createElement("g", {
  id: "download-(3)",
  transform: "translate(116.000000, 0.000000)"
}, React.createElement("path", {
  d: "M47.91625,30 L2.08375,30 C0.9375,30 0,29.1 0,28 L0,2 C0,0.9 0.9375,0 2.08375,0 L47.91625,0 C49.0625,0 50,0.9 50,2 L50,28 C50,29.1 49.0625,30 47.91625,30 Z",
  id: "Shape",
  fill: "#1477BE"
}), React.createElement("path", {
  d: "M7.825,15.4 L10.71625,15.4 L9.26875,12.075 L7.825,15.4 Z M34.19125,12.47125 L29.51875,12.47125 L29.51875,14.00875 L34.10125,14.00875 L34.10125,15.73875 L29.5075,15.73875 L29.5075,17.47 L34.28375,17.47 L34.28375,18.72625 C35.0625,17.76375 35.94625,16.89375 36.815,15.9325 L37.69875,14.97 C36.53125,13.715 35.36125,12.37 34.19375,11.12625 L34.19375,12.4725 L34.19125,12.47125 Z",
  id: "Shape",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M47.8125,8.75 L40.80625,8.75 L39.14625,10.5 L37.59,8.75 L21.23,8.75 L19.95875,11.77 L18.59625,8.75 L6.62125,8.75 L1.5625,20.625 L7.595,20.625 L8.37375,18.68 L10.12375,18.68 L10.9025,20.625 L37.4875,20.625 L39.14625,18.77125 L40.80625,20.625 L47.8125,20.625 L42.3625,14.79125 L47.8125,8.75 Z M25.70625,18.875 L23.76,18.875 L23.76,12.35375 L20.84125,18.875 L19.17875,18.875 L16.2625,12.35375 L16.1575,18.875 L12.1625,18.875 L11.38375,16.93 L7.29625,16.93 L6.415,18.875 L4.275,18.875 L7.88,10.41 L10.905,10.41 L14.21125,18.20125 L14.21125,10.4125 L17.51875,10.4125 L20.1525,16.05 L22.4875,10.4125 L25.70625,10.4125 L25.70625,18.875 Z M44.115,18.875 L41.585,18.875 L39.055,16.05 L36.52625,18.875 L27.575,18.875 L27.575,10.41 L36.9125,10.41 L39.15625,13.13125 L41.68625,10.41 L44.2175,10.41 L40.325,14.6875 L44.115,18.875 Z",
  id: "Shape",
  fill: "#FFFFFF"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "50px",
    height: "30px",
    viewBox: "0 0 50 30",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/icon-amex.9dd92932.svg";
export { SvgComponent as ReactComponent };